import React, { useRef, useState } from 'react';
import Recaptcha from 'react-recaptcha';
import { Link } from 'react-router-dom';

const URL = process.env.REACT_APP_API;

const Form = () => {
    const [error, setError] = useState("")
    const [success, setSuccess] = useState("")
    const [recaptcha, setRecaptcha] = useState(true)
    const emailEl = useRef(null)
    const gdprEl = useRef(null)

    const handleFormSubmit = (event) => {
        event.preventDefault();
        let emailid = emailEl.current.value;
        let gdpr = gdprEl.current.checked;

        // Validations
        if (new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(emailid) === false) {
            setError("Please enter a valid email.");
            return;
        } else if (!gdpr) {
            setError("Please complete the captcha");
            return;
        } else if (recaptcha === false) {
            setError("We need your consent to store your email ID and associate it with the device certificates that we have created for you. Note that we do not store the actual certificates and they cannot be recovered if you lose them.");
            return;
        } else {
            setError("")
        }

        if (!error) {
            fetch(URL, {
                method: 'POST',
                body: JSON.stringify({
                    email: emailid,
                    cloud: "aws"
                }),
            })
                .then(resp => resp.json())
                .then(data => {
                    if (data.status === "failure") {
                        setError(data.description)
                    } else if (data.status === "success") {
                        setSuccess(data.description)
                    }
                })
                .catch(error => setError(error))
            
            emailEl.current.value = ""
            gdprEl.current.checked = false
            setRecaptcha(false)
        }
    }
    
    var callback = () => {
        return
    }

    var verifyCallback = function (response) {
        response ? setRecaptcha(true) : setRecaptcha(false)
    };

    return ( 
        <form onSubmit={handleFormSubmit}>
            <div className="form-group">
                <label htmlFor="email">Email address:</label>
                <input
                    type="email"
                    className="form-control"
                    id="email"
                    aria-describedby="emailHelp"
                    ref={emailEl}/>
            </div>
            <div className="form-group">
                <Recaptcha
                sitekey={process.env.REACT_APP_CAPTCHA_KEY}
                render="explicit"
                onloadCallback={callback}
                verifyCallback={verifyCallback}
            />
            </div>
            <div className="form-group form-check">
                <input
                    type="checkbox"
                    className="form-check-input"
                    id="gdpr"
                    value={true}
                    ref={gdprEl}/>
                <label className="form-check-label" htmlFor="gdpr">
                    <small className="form-text text-muted">
                    Please check here to provide consent to store your email address. Please read our privacy policy&nbsp;
                    <Link to="/privacy-policy" className="link" target="_blank" rel="noopener noreferrer">here</Link>
                        &nbsp;.
                    </small>
                </label>
            </div>
            {
                error && <div className="alert alert-danger" role="alert">{error}</div>
            }
            {
                success && <div className="alert alert-success" role="alert">{success}</div>
            }
            <button type="submit" className="btn btn-custom">Generate</button>
        </form>
     );
}
 
export default Form;